import React from 'react';
import UploadComponent from './UploadComponent';

export function Upload({ getFolders, createFolder, users, handleUpload, setFolderUid, multiple, size, fileTypes, getFilesFromFileSystem }: any) {
	return (
		<UploadComponent
			getFolders={getFolders}
			createFolder={createFolder}
			users={users}
			handleUpload={handleUpload}
			setFolderUid={setFolderUid}
			multiple={multiple}
			size={size}
			fileTypes={fileTypes}
			getFilesFromFileSystem={getFilesFromFileSystem}
		/>
	)
}
